// src/pdfWorkerInit.ts
import {pdfjs} from 'react-pdf';

// 1. On importe l'URL du worker compilé par Vite (plus simple et conforme)
import workerUrl from './pdf.worker.ts?worker&url';

// 2. On passe l'URL à PDF.js
pdfjs.GlobalWorkerOptions.workerSrc = workerUrl;
